import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { BnLoadingService, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import {ModalidadeOperacionalRepasse} from '../../../model/modalidade-operacional-repasse.model';
import { ModalConfirmDialogServiceService } from 'src/app/shared/modal-confirm-dialog/modal-confirm-dialog.service.service';
import { ProdutosPermitidosService } from '../produtos-permitidos.service';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import Utils from '../../../shared/fgi-utils';

@Component({
  selector: 'app-produtos-permitidos-listagem',
  standalone: false,
  templateUrl: 'produtos-permitidos-listagem.html'
})

export class ProdutosPermitidosListagem implements  OnInit {

  @Input() public produtosPermitidos: ModalidadeOperacionalRepasse[] = [];
  @Output() public atualizarListagem: EventEmitter<any> = new EventEmitter<any>();

  public atributosOrdenacao: EntityOrderedRequestParameters;

  constructor(
    private confirmService: ModalConfirmDialogServiceService,
    private produtosService: ProdutosPermitidosService,
    private alertsService: BnAlertsService,
    private loadingService: BnLoadingService,
  ) {}

  ngOnInit() {
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacaoConsulta(this.atributosOrdenacao);
  }

  pesquisarOrdenacaoConsulta(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'valor') {
      funcao = parseFloat;
    }
    this.produtosPermitidos = this.produtosPermitidos.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
      else {
        return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

  excluirProduto(id: number) {
    if (id && id != undefined) {
      this.loadingService.bloqueiaTela();
      this.produtosService.excluirProdutoModalidadeOperacional(id).subscribe({
        next: () => {
          this.chamarAtualizacaoListagem();
          this.loadingService.liberaTela();
          this.alertsService.alertaSucesso("Sucesso", `Produto ${id} excluído com sucesso.`);
        },
        error: () => {
          this.loadingService.liberaTela();
          this.alertsService.alertaErro("Erro", "Erro ao excluir produto.");
        }
      })

    }
  }


  mudarStatusProduto(id: number) {
    if (id && id != undefined) {
      this.loadingService.bloqueiaTela();
      this.produtosService.mudaStatusPermitidaProdutoModalidadeOperacional(id).subscribe({
        next: () => {
          let mensagem = `Produto ${id} atualizado com sucesso.`;
          const produto = this.produtosPermitidos.find(p => p.id === id);
          if (produto) {
            if (!produto.permitida) {
              mensagem = 'Código de modalidade operacional ativado';
            } else {
              mensagem = 'Código de modalidade operacional desativado';
            }
          }
          this.alertsService.alertaSucesso("Sucesso", mensagem);
          this.chamarAtualizacaoListagem();
          this.loadingService.liberaTela();
        },
        error: () => {
          this.loadingService.liberaTela();
          this.alertsService.alertaErro("Erro", "Erro ao atualizar produto.");
        }
      })
    }
  }

  async chamarModalExluirProduto(id: number) {
    const confirmado = await this.confirmService.confirm('Confirmar exclusão do produto?');

    if (confirmado) {
      this.excluirProduto(id);
    }
  }

  chamarAtualizacaoListagem() {
    this.atualizarListagem.emit(null);
  }

  tooltipMudarStatus(produto: ModalidadeOperacionalRepasse) {
    if (produto.permitida) {
      return 'Desativa um produto'
    } else {
      return 'Ativa um produto'
    }
  }

}
